import { z } from "zod";

export const interactionTypeSchema = z.enum([
  "field_visit",
  "hallway",
  "phone",
  "email",
  "referral",
  "sticker_observation",
  "other",
]);
export type InteractionType = z.infer<typeof interactionTypeSchema>;

export const captureOutcomeSchema = z.enum([
  "information_captured",
  "nobody_available",
  "wrong_person",
  "no_new_information",
  "no_answer",
  "no_response",
  "referred_elsewhere",
]);
export type CaptureOutcome = z.infer<typeof captureOutcomeSchema>;

export const communicationDirectionSchema = z.enum([
  "outbound",
  "inbound",
  "unknown",
]);
export type CommunicationDirection = z.infer<
  typeof communicationDirectionSchema
>;

export const interactionTypeLabels: Record<InteractionType, string> = {
  field_visit: "Field visit",
  hallway: "Hallway visit",
  phone: "Phone call",
  email: "Email",
  referral: "Referral",
  sticker_observation: "Sticker observed",
  other: "Other",
};

export const captureOutcomeLabels: Record<CaptureOutcome, string> = {
  information_captured: "Information captured",
  nobody_available: "Nobody available",
  wrong_person: "Wrong person",
  no_new_information: "No new information",
  no_answer: "No answer",
  no_response: "No response",
  referred_elsewhere: "Referred elsewhere",
};

export const communicationDirectionLabels: Record<
  CommunicationDirection,
  string
> = {
  outbound: "Outbound",
  inbound: "Inbound",
  unknown: "Unknown",
};
